<app-marine-insurance-card [cardTitle]="'INFO.SHIP.TITLE'" [isCanEdit]="true" (edit)="edit.emit()">
  <ng-container body>
    <div class="marine-insurance-shipment-details-view-data">
      <div class="marine-insurance-shipment-details-view-data-cell">
        <div class="marine-insurance-shipment-details-view-data-cell-label">
          {{ "TRANSPORTATION" | translate }}
          <img src="assets/icons/icon_attention_sm.svg" *ngIf="isUpdatedPlainField('transportationMode', 'updatedTransportationMode')" />
        </div>
        <div class="marine-insurance-shipment-details-view-data-cell-value">
          {{ transportationValue | translate }}
        </div>
      </div>

      <div class="marine-insurance-shipment-details-view-data-cell">
        <div class="marine-insurance-shipment-details-view-data-cell-label">
          {{ "LABELS.FROM" | translate }}
          <img src="assets/icons/icon_attention_sm.svg" *ngIf="isUpdatedFrom" />
        </div>
        <div class="marine-insurance-shipment-details-view-data-cell-value">
          {{ fromValue }}
        </div>
      </div>

      <div class="marine-insurance-shipment-details-view-data-cell" *ngIf="isOcean">
        <div class="marine-insurance-shipment-details-view-data-cell-label">
          {{ vesselNameLabel | translate }}
          <img src="assets/icons/icon_attention_sm.svg" *ngIf="isUpdatedPlainField('vesselName', 'updatedVesselName')" />
        </div>
        <div class="marine-insurance-shipment-details-view-data-cell-value">
          {{ vesselNameValue }}
        </div>
      </div>

      <div class="marine-insurance-shipment-details-view-data-cell">
        <div class="marine-insurance-shipment-details-view-data-cell-label">
          {{ "PACKING_TYPE" | translate }}
          <img src="assets/icons/icon_attention_sm.svg" *ngIf="isUpdatedPackingType" />
        </div>
        <div class="marine-insurance-shipment-details-view-data-cell-value">
          {{ packingTypeValue | translate }}
        </div>
      </div>

      <div class="marine-insurance-shipment-details-view-data-cell">
        <div class="marine-insurance-shipment-details-view-data-cell-label">
          {{ "LABELS.TO" | translate }}
          <img src="assets/icons/icon_attention_sm.svg" *ngIf="isUpdatedTo" />
        </div>
        <div class="marine-insurance-shipment-details-view-data-cell-value">
          {{ toValue }}
        </div>
      </div>

      <div class="marine-insurance-shipment-details-view-data-cell">
        <div class="marine-insurance-shipment-details-view-data-cell-label">
          {{ voyageNumberLabel | translate }}
          <img src="assets/icons/icon_attention_sm.svg" *ngIf="isUpdatedPlainField('voyageNumber', 'updatedVoyageNumber')" />
        </div>
        <div class="marine-insurance-shipment-details-view-data-cell-value">
          {{ voyageNumberValue }}
        </div>
      </div>

      <div class="marine-insurance-shipment-details-view-data-cell">
        <div class="marine-insurance-shipment-details-view-data-cell-label">
          {{ blLabel | translate }}
          <img src="assets/icons/icon_attention_sm.svg" *ngIf="isUpdatedBL" />
        </div>
        <div class="marine-insurance-shipment-details-view-data-cell-value">
          {{ billNumber }}
        </div>
      </div>

      <div class="marine-insurance-shipment-details-view-data-cell">
        <div class="marine-insurance-shipment-details-view-data-cell-label">
          {{ "LABELS.ETD" | translate }}
          <img src="assets/icons/icon_attention_sm.svg" *ngIf="isUpdatedPlainField('shippingDate', 'updatedShippingDate')" />
        </div>
        <div class="marine-insurance-shipment-details-view-data-cell-value">
          {{ shippingDateValue | customDateByUtc }}
        </div>
      </div>
    </div>
  </ng-container>
</app-marine-insurance-card>
